if($('input[name="company_type"]').length) {
  $(function() {
    /*
    利用申請ページ
    業態によって表示させる項目を調整する
    */
    function companyType() {
      var company_type = $('input[name="company_type"]:checked').val();
      if(company_type == '2' || company_type == '3') {
          $('.js-companyType').fadeIn();
          $('.js-companyType input').prop("required", true);
          $('.js-careCabType').fadeIn();
          $('.js-careCabType.js-required input').prop("required", true);
          $('.js-hospitalType').fadeOut();
          $('.js-hospitalType input').removeAttr("required");
      } else if(company_type == '4') {
          $('.js-hospitalType').fadeIn();
          $('.js-hospitalType input').prop("required", true);
          $('.js-careCabType').fadeOut();
          $('.js-careCabType.js-required input').removeAttr("required");
          $('.js-companyType').fadeOut();
          $('.js-companyType input').removeAttr("required");
      }else{
        $('.js-careCabType').fadeIn();
        $('.js-careCabType.js-required input').prop("required", true);
        $('.js-companyType').fadeOut();
        $('.js-companyType input').removeAttr("required");
        $('.js-hospitalType').fadeOut();
        $('.js-hospitalType input').removeAttr("required");
      }
    }
    companyType();
    $(document).on('change','input[name="company_type"]', function () {
      companyType();
      if($(this).val() !== '4') { // 業態で病院・クリニック以外を選択した場合
        $('.js-credit').fadeIn();
        // 採用マッチング手数料の支払い方法 の選択を解除
        $('[name="payment_method"]').prop('checked', false);
      } else {
          // 通話料・手数料の支払い方法 の選択を解除
          $('[name="company_payment_method"]').prop('checked', false);
      }
    });

    /*
    採用マッチング手数料の支払い方法
    通話料・手数料の支払い方法
    */
    $(document).on('change','input[name="payment_method"], input[name="company_payment_method"]', function () {
      if($(this).val() === '1') { // 銀行振込の場合
        $('.js-credit').fadeOut();
      }else{
        $('.js-credit').fadeIn();
      }
    });
  });
};
